<template>
  <div class="cm-material">
    <div class="title">
      <img src="@/assets/圆圈.png" />
      <div>企划物料</div>
    </div>

    <div class="download" @click="onDownload">
      <img src="@/assets/下载.png" />
      <div>一键批量下载物料</div>
    </div>

    <div class="null" v-if="bean.length < 1">
      <div>暂无内容！</div>
      <img src="@/assets/暂无内容.png" alt />
    </div>

    <div v-if="imageFileList.length > 0">
      <div class="file-title">图片文件（{{imageFileList.length}}）</div>
      <div class="file-list">
        <FileList :list="imageFileList" name="图片" />
      </div>
    </div>

    <div v-if="otherFileList.length > 0">
      <div
        class="file-title"
      >PDF文件（{{otherFileList.filter(e => e.type === 'PDF').length}}）/视频文件（{{otherFileList.filter(e => e.type === 'VIDEO').length}}）/音频文件（{{otherFileList.filter(e => e.type === 'AUDIO').length}}）</div>
      <div class="file-list">
        <FileList :list="otherFileList" />
      </div>
    </div>

    <!-- <div
      class="material"
      v-for="(item, index) in bean"
      :key="index"
      :style="index % 2 == 1 ? 'margin-right: 0;' : ''"
    >
      <div class="left">
        <a data-fancybox="gallery" class="image" :href="util.getImageUrl(item.image, '1000-')">
          <img :src="util.getImageUrl(item.image, '200x200')" />
        </a>
      </div>
      <div class="right">
        <div class="name">{{item.name}}</div>
        <div class="intro">{{item.intro}}</div>
      </div>
    </div>-->
  </div>
</template>

<script>
import FileList from "@/components/service/FileList";

export default {
  name: "CommodityMarketingMaterial",
  components: {
    FileList
  },
  props: ["bean"],
  computed: {
    imageFileList: function() {
      let result = [];

      if (this.bean) {
        this.bean.forEach(element => {
          if (element.image) {
            element.image.split(",").forEach(e => {
              result.push({
                type: this.getFileType(e),
                name: element.name,
                desc: element.intro,
                url: e
              });
            });
          }
          if (element.files) {
            element.files.split(",").forEach(e => {
              result.push({
                type: this.getFileType(e),
                name: element.name,
                desc: element.intro,
                url: e
              });
            });
          }
        });
      }

      return result.filter(e => e.type === "IMAGE");
    },
    otherFileList: function() {
      let result = [];

      if (this.bean) {
        this.bean.forEach(element => {
          if (element.image) {
            element.image.split(",").forEach(e => {
              result.push({
                type: this.getFileType(e),
                name: element.name,
                desc: element.intro,
                url: e
              });
            });
          }
          if (element.files) {
            element.files.split(",").forEach(e => {
              result.push({
                type: this.getFileType(e),
                name: element.name,
                desc: element.intro,
                url: e
              });
            });
          }
        });
      }

      return result
        .filter(
          e => e.type === "PDF" || e.type === "VIDEO" || e.type === "AUDIO"
        )
        .sort((a, b) => {
          return this.getLevel(a.type) - this.getLevel(b.type);
        });
    }
  },
  methods: {
    onDownload() {
      this.$emit("download");
    },
    getLevel(type) {
      if (type == "PDF") {
        return 0;
      } else if (type == "VIDEO") {
        return 1;
      } else if (type == "AUDIO") {
        return 2;
      } else {
        return 3;
      }
    },
    getFileType(e) {
      if (e.endsWith(".png")) {
        return "IMAGE";
      }
      if (e.endsWith(".jpg")) {
        return "IMAGE";
      }
      if (e.endsWith(".mp4")) {
        return "VIDEO";
      }
      if (e.endsWith(".mp3")) {
        return "AUDIO";
      }
      if (e.endsWith(".pdf")) {
        return "PDF";
      }
      return "UNKNOW";
    }
  }
};
</script>

<style lang="less" scoped>
.cm-material {
  width: 1100px;
  margin: 40px 0;
  .title {
    margin: 20px 0;
    img {
      display: inline-block;
      width: 12px;
      height: 12px;

      margin-right: 10px;
    }
    div {
      display: inline-block;
      width: 80px;
      height: 28px;
      font-size: 20px;
      font-weight: 600;
      color: rgba(51, 51, 51, 1);
      line-height: 28px;
    }
  }

  .download {
    width: 180px;
    height: 40px;
    // background: rgba(229, 244, 234, 1);
    border-radius: 3px;
    cursor: pointer;
    float: right;
    margin-top: -50px;

    border-radius: 20px;
    border: 1px solid rgba(27, 153, 79, 1);
    // text-align: right;
    div {
      display: inline-block;
      width: 112px;
      //   height: 20px;
      font-size: 14px;
      font-family: PingFang-SC-Medium;
      font-weight: 500;
      color: rgba(27, 153, 79, 1);
      line-height: 40px;
      vertical-align: top;
    }
    img {
      display: inline-block;
      width: 15px;
      height: 17px;
      margin: 13px 10px 12px 23px;
    }
  }

  .null {
    text-align: center;
    margin: 25px 0;
    img {
      width: 200px;
    }
  }

  .file-title {
    height: 20px;
    font-size: 14px;
    font-weight: 600;
    color: rgba(51, 51, 51, 1);
    line-height: 20px;
    margin-bottom: 20px;
  }

  .file-list {
  }

  .material {
    display: inline-block;
    width: 535px;
    height: 274px;
    margin-right: 30px;
    background: #f7faf8;

    .left {
      display: inline-block;
      vertical-align: top;
      width: 234px;
      margin: 20px;
      img {
        width: 234px;
        height: 234px;
        background: rgba(216, 216, 216, 1);
        border-radius: 5px;
      }
    }
    .right {
      display: inline-block;
      vertical-align: top;
      width: 240px;
      .name {
        margin: 24px 0;
        font-size: 16px;
        font-family: PingFangSC-Semibold;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
        line-height: 22px;
      }

      .intro {
        font-size: 12px;
        font-family: PingFang-SC-Regular;
        font-weight: 400;
        color: rgba(109, 114, 120, 1);
        line-height: 17px;
      }
    }
  }
}
</style>

